import React from 'react';
import cn from 'classnames';

import { TCarGroup } from '@/types';
import { GROUP_TITLE_MAP } from '@/constants';

import style from './style.module.scss';

type CarGroupProps = {
  status: TCarGroup;
  // eslint-disable-next-line react/require-default-props
  className?: string;
  label?: string;
};

const CAR_GROUP_COLOR_MAP: Record<TCarGroup, string> = {
  new: '#00368F',
  used: '#E20109',
};

const CarGroup = ({ status, className, label }: CarGroupProps) => {
  return (
    <div className={cn(style.root, className)}>
      <div
        className={style.ellipse}
        style={{ backgroundColor: CAR_GROUP_COLOR_MAP[status] }}
      />
      <span>{label || GROUP_TITLE_MAP[status]}</span>
    </div>
  );
};

export default CarGroup;
